<field-boolean-readonly *ngIf="field.readonly; else editable" [field]="field"></field-boolean-readonly>
<ng-template #editable>
  <field-boolean-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-boolean-single>
</ng-template>


